/* eslint-disable lingui/text-restrictions */

import { t } from "@lingui/macro";

import { axios } from "@/client/libs/axios";
import { pollAIResult } from "../ai/poll";

export const improveWriting = async (text: string) => {
  const result = await axios.post<{ key: string }>("/ai/improve-writing", {
    data: text,
  });
  const improvedText = await pollAIResult<string>(result.data.key);
  if (!improvedText) {
    throw new Error(t`The server did not return improved text for your input.`);
  }

  return improvedText;
};
